import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';

/**
 * Section 7 — Entertainment & Travel
 */
export default function StepEntertainmentTravel({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const fields = [
    { key: 'books_magazines_movies_music', label: 'Books, Magazines, Movies & Music' },
    { key: 'concerts_events', label: 'Concerts & Events' },
    { key: 'sports_hobbies_activities', label: 'Sports, Hobbies & Activities' },
    {
      key: 'streaming_subscriptions',
      label: 'Streaming Services & Subscriptions',
      hint: 'Netflix, HBO, YouTube, Apple Music, Dropbox, antivirus, apps, Amazon Prime, etc.',
    },
    { key: 'travel_vacation', label: 'Travel & Vacation' },
    { key: 'miscellaneous_entertainment', label: 'Miscellaneous Entertainment' },
  ];

  const total = fields.reduce(
    (sum, f) => sum + (Number(data[f.key]) || 0),
    0
  );

  return (
    <div>
      <SectionHeader number={7} title="Entertainment & Travel" />

      <div className="cashflow-field-grid">
        {fields.map(({ key, label, hint }) => (
          <CurrencyInput
            key={key}
            id={key}
            label={label}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
            hint={hint}
          />
        ))}
      </div>

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">7: Total Entertainment & Travel</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
